import React from 'react';

const JavaScript = () => {
  return (
    <div >
      <h1>JavaScript</h1>
      <p>Placeholder component for: "JavaScript"</p>
    </div>
  );
};

export default JavaScript;
